export default "__VITE_ASSET__CqquJ4jp__"